import { render, staticRenderFns } from "./CACA-Senior.vue?vue&type=template&id=6d612f20&scoped=true"
import script from "./CACA-Senior.vue?vue&type=script&lang=js"
export * from "./CACA-Senior.vue?vue&type=script&lang=js"
import style0 from "./CACA-Senior.vue?vue&type=style&index=0&id=6d612f20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d612f20",
  null
  
)

export default component.exports